import { Suspense } from "react";
import { Navigate } from "react-router-dom";
import PageLoader from "../components/PageLoader";
import { useSelector } from "react-redux";
import TermsProtectedRoute from "../components/TermsProtectedRoute";

const PrivateRoute = ({ children, requiredRoles = [] }) => {
  // Get access token from local storage
  const accessToken = localStorage.getItem("token");
  const { selectedCompany } = useSelector((state) => state?.auth);

  const userRole = selectedCompany?.role_slug || ""; // Ensure role is a string

  // Check if the user has access
  if (!accessToken) {
    return <Navigate to="/login" />;
  }

  // Check if user has any of the required roles
  const hasRequiredRole =
    requiredRoles.length === 0 || requiredRoles.includes(userRole);
  if (!hasRequiredRole) {
    return <Navigate to="/dashboard" />;
  }

  // Wrap the children with TermsProtectedRoute
  return (
    <Suspense fallback={<PageLoader />}>
      <TermsProtectedRoute>
        {children}
      </TermsProtectedRoute>
    </Suspense>
  );
};

export default PrivateRoute;
